/**
 * Debugging helpers for full-document duplication (often Yjs double-seed / race).
 * All logs use the prefix "[DUPLICATION DEBUG]" for easy filtering.
 */

/**
 * Detect classic "entire doc pasted twice" patterns in plain text.
 */
export function analyzeTextDuplication(plainText) {
  if (!plainText || typeof plainText !== "string") {
    return { suspected: false, reason: "empty_or_invalid" };
  }
  const t = plainText.replace(/\r\n/g, "\n");
  const len = t.length;
  if (len < 200) {
    return { suspected: false, reason: "too_short_to_analyze", length: len };
  }

  const half = Math.floor(len / 2);
  const a = t.slice(0, half);
  const b = t.slice(half);
  if (a === b) {
    return {
      suspected: true,
      pattern: "exact_two_halves",
      reason:
        "Plain text is two identical halves — typical of double Yjs seed, double setContents, or merged duplicate snapshots",
      length: len,
      halfLength: half,
    };
  }

  const aTrim = a.replace(/\s+$/u, "");
  const bTrim = b.replace(/^\s+/u, "");
  if (
    aTrim.length > 150 &&
    bTrim.length > 150 &&
    aTrim === bTrim.slice(0, aTrim.length)
  ) {
    return {
      suspected: true,
      pattern: "trimmed_prefix_match_second_half",
      reason:
        "First half (trimmed) matches start of second half — likely duplicated block with minor whitespace",
      length: len,
    };
  }

  return { suspected: false, reason: "no_simple_pattern", length: len };
}

/**
 * @param {string} phase - Short label, e.g. "post-binding", "fetch-setContents"
 * @param {Record<string, unknown>} details
 */
export function logDuplicationDebug(phase, details = {}) {
  const payload = { phase, ts: new Date().toISOString(), ...details };
  console.warn("[DUPLICATION DEBUG]", phase, payload);
  return payload;
}
